import { del, get, post, put, patch } from 'utils/fetch';
import endpoints, { EEndpoints } from 'config/endpoints';
import { admins as typesAdmins } from 'types';
import { TAdminsUpdateParams } from 'types/entities/admins';

const admins = {
    add(reqBody: typesAdmins.TAdminsAddParams) {
        return post<typesAdmins.TAdminsAddParams, null>(
            `${endpoints[EEndpoints.admins]()}`,
            {
                ...reqBody,
            },
        );
    },
    del({ id }: typesAdmins.TAdminsDelParams) {
        return del<null>(`${endpoints[EEndpoints.adminsDel](id)}`);
    },
    get() {
        return get<typesAdmins.TAdmins[]>(`${endpoints[EEndpoints.admins]()}`);
    },
    unblock({ id }: typesAdmins.TAdminsUnblockParams) {
        return put<typesAdmins.TAdminsUnblockParams, null>(
            `${endpoints[EEndpoints.adminsUnblock](id)}`,
        );
    },
    getPermissionRoles() {
        return get<typesAdmins.TAdminPermissionRole[]>(
            `${endpoints[EEndpoints.adminPermissionRoles]()}`,
        );
    },
    updateAdmin(reqBody: TAdminsUpdateParams) {
        return patch<TAdminsUpdateParams, null>(
            `${endpoints[EEndpoints.adminsUpdate](reqBody.adminId)}`,
            {
                ...reqBody,
            },
        );
    },
    getAdminActivityLogs({ query }: { query: string }) {
        return get<typesAdmins.TGetAdminActivityLogsResponse>(
            `${endpoints[EEndpoints.adminActivityLogs]()}?${query}`,
        );
    },
    getAdminActivityLogDetail({
        id,
    }: typesAdmins.TGetAdminActivityLogDetailRequest) {
        return get<typesAdmins.TGetAdminActivityLogDetailResponse>(
            `${endpoints[EEndpoints.adminActivityLogDetail](id)}`,
        );
    },
};

export default admins;
